import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import './App.css';
import { useEffect, useState, lazy, Suspense } from 'react';
import { Navigate, Routes, Route, useLocation } from 'react-router-dom';
import { Button, Spinner } from 'react-bootstrap';
import { ArrowCircleUp } from '@phosphor-icons/react';
import { useSelector } from 'react-redux';
import Header from './Pages/Header';
import Footer from './Pages/Footer';
import MatomoTracker from './matomoTracking/MatomoTracker';
import MatomoTrackerAction from './matomoTracking/MatomoTrackerAction';
import { fetchTotalVisits } from './matomoTracking/fetchTotalVisits';
import Index from './Pages/Home';
import About from './Pages/About';
import Faq from './Pages/Faq';
import TermsConditionsPage from './Pages/TermsConditionsPage';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import { getDefaultLang, routeLocation, routePathname, splitLangPath, withLang } from './utils/language';
import SEO from './component/SEO';

const FunnelApp = lazy(() => import('./funnel/FunnelApp'));

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [statsData, setStatsData] = useState({});
  const location = useLocation();
  const { prefix, path: barePath } = splitLangPath(location.pathname);
  const legacyLang = new URLSearchParams(location.search).get('lang');
  const isFunnelRoute = routePathname(location.pathname).startsWith('/fup-funnel');
  const CMSData = useSelector(state => state.cmsdatadetail.cmsdatadetail);
  const CMSLoading = useSelector(state => state.cmsdatadetail.loading);

  useEffect(() => {
    const toggleVisibility = () => setIsVisible(window.pageYOffset > 200);
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  MatomoTrackerAction();
  useEffect(() => {
    let mounted = true;
    fetchTotalVisits().then(data => {
      if (mounted && data) setStatsData(data);
    });
    return () => (mounted = false);
  }, []);

  if (legacyLang === 'en' || legacyLang === 'ori') {
    const params = new URLSearchParams(location.search);
    params.delete('lang');
    const search = params.toString();
    const target = `${withLang(barePath, legacyLang)}${search ? `?${search}` : ''}${location.hash}`;
    return <Navigate to={target} replace />;
  }

  if (prefix === getDefaultLang()) {
    return <Navigate to={`${barePath}${location.search}${location.hash}`} replace />;
  }

  if (isFunnelRoute) {
    return (
      <Suspense fallback={
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner animation="grow" variant="success" />
        </div>
      }>
        <FunnelApp />
      </Suspense>
    );
  }

  return (
    <>
      <SEO />
      <MatomoTracker />

      {CMSLoading || !CMSData ? (
        <div className="d-flex justify-content-center align-items-center vh-100">
          <Spinner animation="grow" variant="success" />
        </div>
      ) : (
        <>
          <Header />

          <Routes location={routeLocation(location)}>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/termsConditions" element={<TermsConditionsPage />} />
            <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
          </Routes>

          <Footer data={statsData} />

          {isVisible && (
            <Button onClick={scrollToTop} className="scroll-to-top-button">
              <ArrowCircleUp size={32} />
            </Button>
          )}
        </>
      )}
    </>
  );
}

export default App;
